import request from '@/utils/request'

export function getResourceRelationshipList(data) {
    return request({
        url: '/backend/xiao/resource/getResourceRelationshipList',
        method: 'post',
        data: data
    })
}

export function setRelationship(data) {
    return request({
        url: '/backend/xiao/resource/setRelationship',
        method: 'post',
        data: data
    })
}

export function getExperienceRelationshipList(data) {
    return request({
        url: '/backend/xiao/resource/getExperienceRelationshipList',
        method: 'post',
        data: data
    })
}

export function deleteExpRelationship(data) {
    return request({
        url: '/backend/xiao/resource/deleteExpRelationship',
        method: 'post',
        data: data
    })
}

export function screenExperienceList(data) {
    return request({
        url: '/backend/xiao/resource/screenExperienceList',
        method: 'post',
        data: data
    })
}

export function setExpRelationship(data) {
    return request({
        url: '/backend/xiao/resource/setExpRelationship',
        method: 'post',
        data: data
    })
}

export function setExpRelationshipSort(data) {
    return request({
        url: '/backend/xiao/resource/setExpRelationshipSort',
        method: 'post',
        data: data
    })
}


export function relationExpRelation(data) {
    return request({
        url: '/backend/xiao/resource/relationExpRelation',
        method: 'post',
        data: data
    })
}

export function shareUserList(data) {
    return request({
        url: '/backend/xiao/liebian/shareUserList',
        method: 'post',
        data: data
    })
}

export function searchUser(data) {
    return request({
        url: '/backend/xiao/liebian/searchUser',
        method: 'post',
        data: data
    })
}

export function addShareUser(data) {
    return request({
        url: '/backend/xiao/liebian/addShareUser',
        method: 'post',
        data: data
    })
}

export function delShareUser(data) {
    return request({
        url: '/backend/xiao/liebian/delShareUser',
        method: 'post',
        data: data
    })
}